<template>
  <div :class="'p-option --' + product">
    <input
      type="checkbox"
      :id="pid + '-' + product"
      class="c-checkbox"
      v-model="checkboxOption"
    />
    <label :for="pid + '-' + product" class="c-checkbox--label p-option__title"
      >選択</label
    >
    <div class="p-option__body" :class="checkboxOption ? '' : '--off'">
      <div class="p-option__abstract">
        <p
          class="p-option__catch p-option__catch--caution"
          v-html="productObj.CAUTION"
        ></p>
        <p
          class="p-option__catch p-option__catch--before"
          v-html="productObj.BEFORE_TITLE"
        ></p>
        <h2 class="p-option__heading" v-html="productObj.TITLE"></h2>
        <p class="p-option__catch" v-html="productObj.AFTER_TITLE"></p>
        <a
          :href="'/service/' + product"
          target="_blank"
          class="p-option__more"
          >詳しく見る ▶</a
        >
      </div>
      <dl
        class="p-option__dl"
        v-for="condition in productObj.CONDITIONS"
        :key="condition.ID"
        v-show="
          !(
            // (pid !== 'p1' && condition.ID === 'injury') ||
            (thePerson.age < 15 && condition.ID === 'compensation')
          )
        "
      >
        <dt class="p-option__dt">{{ condition.NAME }}</dt>
        <dd class="p-option__dd">
          <template v-if="condition.OPTIONS === undefined">
            <select
              :value="getPerson(pid).options[product][condition.ID]"
              @change="setCondition($event.target.value, condition.ID)"
              :disabled="!checkboxOption"
              class="p-option__select"
            >
              <!-- <select v-else :value="getCondition" @change="(setCondition(value))" class="p-option__select"> -->
              <option></option>
              <option
                v-for="label in labels(condition)"
                :key="label.VALUE"
                :value="label.LABEL"
              >
                {{ label.LABEL }}
              </option>
            </select>
          </template>
          <template v-else>
            <template v-for="option in condition.OPTIONS" :key="option.ID">
              <select
                :value="
                  getPerson(pid).options[product][condition.ID][option.ID]
                "
                @change="
                  setConditionOption(
                    $event.target.value,
                    condition.ID,
                    option.ID
                  )
                "
                :disabled="!checkboxOption"
                class="p-option__select"
              >
                <option></option>
                <option
                  v-for="label in labels(option)"
                  :key="label.VALUE"
                  :value="label.LABEL"
                >
                  {{ label.LABEL }}
                </option>
              </select>
            </template>
          </template>
          <template v-if="condition.NOTE !== undefined">
            <p class="p-option__note" v-html="condition.NOTE"></p>
          </template>
        </dd>
      </dl>
      <div class="p-option__fee">
        <p class="p-option__fee__title">毎月の保険料</p>
        <p class="p-option__fee__price">
          {{ priceFormat(getSum) }}<span>円</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GENDER_LABELS,
  PERSON_LABELS,
  LIFESTAGE_LABELS,
  INS_PRODUCTS_LABELS,
} from "@/const.js";
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";

export default {
  name: "OptionForm",
  beforeMount() {
    this.validating();
    this.$emit("update-condition", this.getSum);
  },
  components: {},
  props: {
    product: String,
    pid: String,
  },
  data() {
    return {
      sum: 0,
      validated: false,
      conditionsValidated: {},
    };
  },
  computed: {
    ...mapGetters([
      "getPerson",
      "getPrice",
      "getOptionPrice",
      "getValueFromLabel",
      "priceFormat",
      // "getSubtotal",
    ]),
    genders() {
      return GENDER_LABELS;
    },
    persons() {
      return PERSON_LABELS;
    },
    lifestages() {
      return LIFESTAGE_LABELS;
    },
    labels() {
      return (con) => {
        // console.log(this.pid);
        // console.log(con.ID);
        // console.log(con.LABELS_SUB);
        if (con.LABELS_SUB !== undefined && this.pid === "p2") {
          return con.LABELS_SUB;
        } else if (
          con.LABELS_CHILD !== undefined &&
          (this.pid === "p3" || this.pid === "p4")
        ) {
          return con.LABELS_CHILD;
        } else if (con.ID === "medical" && this.thePerson.gender === "男性") {
          return con.LABELS.filter((l) => l.VALUE < 5);
          // 男性は医療保険の5番目以降適用外
        } else {
          return con.LABELS;
        }
      };
    },
    insProducts() {
      return INS_PRODUCTS_LABELS;
    },
    productObj() {
      return this.insProducts.find((pro) => pro.ID === this.product);
    },
    thePerson() {
      return this.getPerson(this.pid);
    },
    checkboxOption: {
      get() {
        // console.log(
        //   "checkboxOption:" +
        //     this.pid +
        //     ":" +
        //     this.product +
        //     "=" +
        //     this.getPerson(this.pid).options[this.product].insured
        // );
        return this.getPerson(this.pid).options[this.product].insured;
      },
      set(value) {
        this.$store.commit("updateOption", {
          value,
          personId: this.pid,
          product: this.product,
        });
        // this.clearValues();
        this.validating();
      },
    },
    getSum() {
      let sum = 0;
      this.productObj.CONDITIONS.forEach((con) => {
        // console.log(con);
        // console.log(this.thePerson);
        if (con.OPTIONS === undefined) {
          sum += this.getPrice(
            this.product + "-" + con.ID,
            this.getValueFromLabel(GENDER_LABELS, this.thePerson.gender),
            this.thePerson.age,
            this.getValueFromLabel(
              this.product + "-" + con.ID === "seimei-course" &&
                (this.pid === "p3" || this.pid === "p4")
                ? con.LABELS_CHILD
                : con.LABELS,
              this.thePerson.options[this.product][con.ID]
            ),
            this.pid
          );
        } else {
          let values = [];
          con.OPTIONS.forEach((option) => {
            // console.log(
            //   this.thePerson.options[this.product][con.ID][option.ID]
            // );
            values.push(
              this.getValueFromLabel(
                option.LABELS,
                this.thePerson.options[this.product][con.ID][option.ID]
              )
            );
          });
          if (values.filter((v) => !!v).length === values.length) {
            sum += this.getOptionPrice(
              this.product + "-" + con.ID,
              this.getValueFromLabel(GENDER_LABELS, this.thePerson.gender),
              this.thePerson.age,
              values
            );
          }
        }
      });
      return sum;
    },
    // subtotal() {
    //   return this.getSubtotal(this.product, this.pid);
    // },
    // getCondition() {
    //   return this.getPerson(this.pid).options[this.product][
    //       this.conditionId
    //     ];
    // },
    // selectCondition: {
    //   get() {
    //     console.log(this.conditionId);
    //     return (cid) => {
    //       this.getPerson(this.pid).options[this.product][cid];
    //     };
    //   },
    //   set(value) {
    //     this.$store.commit("updateCondition", {
    //       value,
    //       personId: this.pid,
    //       product: this.product,
    //       conditionId: this.conditionId,
    //     });
    //   },
    // },
    // selectConditionOption: {
    //   get() {
    //     return this.getPerson(this.pid).options[this.product][
    //       this.conditionId
    //     ][this.conditionOptionId];
    //   },
    //   set(value) {
    //     this.$store.commit("updateConditionOption", {
    //       value,
    //       personId: this.pid,
    //       product: this.product,
    //       conditionId: this.conditionId,
    //       conditionOptionId: this.conditionOptionId,
    //     });
    //   },
    // },
  },
  methods: {
    ...mapMutations(["changePage"]),
    move(next) {
      this.changePage({ next });
    },
    // setConditionId(id) {
    //   this.conditionId = id;
    // },
    // setConditionOptionId(id) {
    //   this.conditionOptionId = id;
    // },
    setCondition(value, cid) {
      this.$store.commit("updateCondition", {
        value,
        personId: this.pid,
        product: this.product,
        conditionId: cid,
      });
      this.$emit("update-condition", this.getSum);
      this.conditionsValidated[cid] = !!value;
      this.validating();
      // this.$store.commit("updateSubtotal", {
      //   personId: this.pid,
      //   product: this.product,
      //   sum: this.getSum,
      // });
    },
    setConditionOption(value, cid, oid) {
      this.$store.commit("updateConditionOption", {
        value,
        personId: this.pid,
        product: this.product,
        conditionId: cid,
        optionId: oid,
      });
      this.$emit("update-condition", this.getSum);
      const cObj = this.getPerson(this.pid).options[this.product][cid];
      let validated = true;
      Object.keys(cObj).forEach((key) => {
        validated == validated && !!cObj[key];
      });
      this.conditionsValidated[cid] = validated;
      this.validating();
    },
    clearValues() {
      this.productObj.CONDITIONS.forEach((con) => {
        if (con.OPTIONS === undefined) {
          this.setCondition(null, con.ID);
        } else {
          con.OPTIONS.forEach((opt) => {
            this.setConditionOption(null, con.ID, opt.ID);
          });
        }
      });
    },
    validating() {
      const pObj = this.getPerson(this.pid).options[this.product];
      let validated = true;
      Object.keys(pObj).forEach((key) => {
        // console.log('pObj['+key+']:'+pObj[key]+':'+!!pObj[key]);
        validated = validated && !!pObj[key];
      });
      // console.log('validated:'+validated);
      this.validated = !this.checkboxOption || validated;
      this.$emit("update-validation", this.validated);
    },
    //
    // isCheckedOption(cid, oid, label) {
    //   console.log(label);
    //   console.log(this.getPerson(this.pid).options[this.product][cid][oid]);
    //   return (
    //     this.getPerson(this.pid).options[this.product][cid][oid] == label
    //   );
    // },
    // setCheckedOption(value, cid, oid) {
    //   this.$store.commit("updateConditionOption", {
    //     value,
    //     personId: this.pid,
    //     product: this.product,
    //     conditionId: cid,
    //     conditionOputionId: oid,
    //   });
    // },
  },
};
</script>
  
  <style scoped lang="scss">
.p-option {
  position: relative;
  margin-bottom: 50px;
  &:before {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 35px;
    color: #fff;
    font-weight: 800;
    font-size: 18px;
    text-align: right;
    box-sizing: border-box;
    padding-right: 10px;
  }
  &.--shushin:before {
    content: "充実プラン";
    background-color: $color-shushin-sub;
  }
  &.--tsumitate:before {
    content: "貯蓄・節税プラン";
    background-color: $color-tsumitate-sub;
  }
  &__title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background-color: $color-text;
    color: #fff;
    width: 103px;
    height: 35px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    font-weight: 800;
    font-size: 14px;
    padding-left: 40px;
    .--seimei & {
      background-color: $color-seimei;
    }
    .--seikatsu & {
      background-color: $color-seikatsu;
    }
    .--shushin & {
      background-color: $color-shushin;
    }
    .--tsumitate & {
      background-color: $color-tsumitate;
    }
  }
  &__body {
    position: relative;
    background-color: #fff;
    @include pc {
      padding: 25px 60px;
    }
    @include sp {
      padding: 26px 16px;
    }
    &.--off {
      &:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.1);
      }
    }
  }
  &__abstract {
    text-align: center;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid $color-bg-footer;
  }
  &__heading {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    border: 5px solid $color-text;
    border-radius: 9999px;
    font-weight: 800;
    height: 54px;
    font-size: 14px;
    .--seimei & {
      color: $color-seimei;
      border-color: $color-seimei-light;
    }
    .--seikatsu & {
      color: $color-seikatsu;
      border-color: $color-seikatsu-light;
    }
    .--shushin & {
      color: $color-shushin;
      border-color: $color-shushin-light;
    }
    .--tsumitate & {
      color: $color-tsumitate;
      border-color: $color-tsumitate-light;
    }
    &:deep span {
      font-size: 10px;
    }
  }
  &__catch {
    margin: 15px 0;
    &--before {
      font-weight: 800;
    }
    &--caution {
      color: $color-red;
      font-weight: 800;
      font-size: 18px;
    }
  }
  &__more {
    display: inline-block;
    padding: 0 10px;
    border: 1px solid $color-text;
    border-radius: 9999px;
    font-size: 12px;
    .--seimei & {
      border-color: $color-seimei;
      color: $color-seimei;
    }
    .--seikatsu & {
      border-color: $color-seikatsu;
      color: $color-seikatsu;
    }
    .--shushin & {
      border-color: $color-shushin;
      color: $color-shushin;
    }
    .--tsumitate & {
      border-color: $color-tsumitate;
      color: $color-tsumitate;
    }
  }
  &__dl {
    margin-bottom: 24px;
  }
  &__dt {
    font-weight: 800;
    font-size: 14px;
    .--seimei & {
      color: $color-seimei;
    }
    .--seikatsu & {
      color: $color-seikatsu;
    }
    .--shushin & {
      color: $color-shushin;
    }
    .--tsumitate & {
      color: $color-tsumitate;
    }
  }
  &__select {
    width: 100%;
    height: 40px;
    font-size: 14px;
    padding: 0 15px;
    border-radius: 3px;
    & + & {
      margin-top: 10px;
    }
    .--seimei & {
      border-color: $color-seimei;
    }
    .--seikatsu & {
      border-color: $color-seikatsu;
    }
    .--shushin & {
      border-color: $color-shushin;
    }
    .--tsumitate & {
      border-color: $color-tsumitate;
    }
  }
  &__fee {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 52px;
    padding: 0 15px;
    .--seimei & {
      background-color: $color-seimei-bg;
    }
    .--seikatsu & {
      background-color: $color-seikatsu-bg;
    }
    .--shushin & {
      background-color: $color-shushin-bg;
    }
    .--tsumitate & {
      background-color: $color-tsumitate-bg;
    }
    &__price {
      font-weight: 800;
      font-size: 30px;
      span {
        font-weight: normal;
        font-size: 18px;
      }
      .--seimei & {
        color: $color-seimei;
      }
      .--seikatsu & {
        color: $color-seikatsu;
      }
      .--shushin & {
        color: $color-shushin;
      }
      .--tsumitate & {
        color: $color-tsumitate;
      }
    }
  }
  &__ul {
    display: flex;
    margin-bottom: 10px;
    @include pc {
      justify-content: flex-start;
      gap: 20px;
    }
    @include sp {
      justify-content: space-between;
    }
  }
  &__li {
    @include sp {
      width: calc((100% - 16px) / 2);
    }
  }
  &__radio {
    $parent: &;
    left: -9999px;
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    border: 0;
    overflow: hidden;
    padding: 0;
    clip: rect(0, 0, 0, 0);
    & + label#{$parent}--label {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 40px;
      background-color: $color-seikatsu-bg;
      color: $color-seikatsu;
      font-size: 14px;
      border-radius: 3px;
      @include pc {
        width: 151px;
      }
      &:hover {
        opacity: 0.7;
        cursor: pointer;
      }
    }
    &:checked + label#{$parent}--label {
      color: #fff;
      background-color: $color-seikatsu;
    }
  }
  &__note {
    margin-top: 10px;
    font-size: 12px;
    color: $color-red;
    line-height: 1.5;
    word-break: break-all;
  }
}
</style>